// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Invite = function Invite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.628 10.164c-.883.504-.8 1.848.14 2.239l5.481 2.285v4.035a1.275 1.275 0 0 0 2.258.816l2.422-2.902 4.84 2.015c.738.31 1.593-.175 1.714-.964l2.5-16.25a1.25 1.25 0 0 0-.527-1.22 1.25 1.25 0 0 0-1.328-.054zm2.035.996 13.34-7.62-8.578 9.585.047.04zm13.09 5.457-6.508-2.715 8.364-9.347z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
